export const BUSINESS_REGISTERATION_START = "BUSINESS_REGISTERATION_START";
export const BUSINESS_REGISTERATION_SUCCESS = "BUSINESS_REGISTERATION_SUCCESS";
export const BUSINESS_REGISTERATION_FAIL = "BUSINESS_REGISTERATION_FAIL";